import React from "react";
import { Grid, Typography } from "@mui/material";
import { useEffect } from "react";
import Firestore from "../firebase/FireStore";
import { useParams } from "react-router-dom";
var currencyFormatter = require("currency-formatter");

function Category() {
  const [products, setProducts] = React.useState([]);
  const { category } = useParams();
  useEffect(() => {
    async function fetchData() {
      let new_products = await Firestore.getItems(category);
      setProducts([...new_products.val]);
    }
    fetchData();
  }, [products]);
  return (
    <Grid
      container
      gap={1}
      sx={{ minHeight: "100vh" }}
      className="mt-1 mb-3 flex items-center justify-center"
    >
      {products ?? products != null
        ? products.map((product) => (
          <>
            <Grid
              item
              xs={11}
              sm={4}
              md={2.5}
              sx={{
                height: "450px",
                border: 2,
                borderRadius: "10px",
                borderColor: "grey",
              }}
            >
              <div
                style={{
                  backgroundImage: `url('${product.image}')`,
                  backgroundSize: "cover",
                  borderRadius: "10px 10px 0px 0px",
                  backgroundPosition: "center center",
                  display: "flex",
                  height: "85%",
                  width: "100%",
                  position: "relative",
                }}
              ></div>
              <div className="mt-2 m-3">
                <Typography>{product.name}</Typography>
                <Typography>{currencyFormatter.format(parseInt(product.price), {
                  symbol: "UGX",
                  precision: 0,
                  format: "%v %s", // %s is the symbol and %v is the value
                })}</Typography>
              </div>
            </Grid>
          </>
        ))
        : null}
    </Grid>
  );
}

export default Category;
